import React, { memo, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model"; // ✅ Import explicitly

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../style/components-style/Grid.css";
import { ResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";
import { Icon } from "@iconify/react";

// ✅ Register AG Grid Modules here
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Grid = memo(
  ({
    columnDefs,
    rowData,
    onGridReady,
    rowSelection,
    onSelectionChanged,
    getRowStyle,
    customMinHeight,
    customMaxheight,
    onColumnMoved,
    onDragStopped,
    gridOptions,
    onHeightChange,
  }) => {
    const minHeight = customMinHeight || 215;
    const rowHeight = 40;
    const maxHeight = customMaxheight || 600;
    const computedHeight = customMinHeight
      ? customMinHeight
      : Math.min(Math.max(minHeight, rowData.length * rowHeight), maxHeight);

    // Memoize default column definitions
    const defaultColDef = useMemo(
      () => ({
        flex: 1,
        minWidth: 100,
        resizable: true,
        sortable: true,
        filter: true,
      }),
      []
    );
    // const myTheme = themeQuartz.withParams({
    //   spacing: 20,
    //   accentColor: "red",
    // });
    // const theme = useMemo(() => {
    //   return myTheme;
    // }, []);

    // Memoize grid options to prevent unnecessary re-renders
    const memoizedGridOptions = useMemo(
      () => ({
        ...gridOptions,
        rowModelType: "clientSide",
        suppressScrollOnNewData: true,
        suppressFieldDotNotation: true,
        suppressReactUi: false,
        suppressPropertyNamesCheck: true,
        suppressAnimationFrame: true,
        enableCellTextSelection: true,
        suppressRowHoverHighlight: true,
        suppressCellSelection: true,
        suppressBrowserResizeObserver: true,
        immutableData: true,
        getRowId: (params) => params.data.id,
        rowBuffer: 20,
        animateRows: false,
      }),
      [gridOptions]
    );

    return (
      <ResizableBox
        className="grid-resizable-box"
        width={Infinity}
        height={computedHeight}
        minConstraints={[100, 500]}
        maxConstraints={[Infinity, 800]}
        handle={
          <div className="custom-resize-handle">
            <Icon icon="vaadin:handle-corner" style={{ color: "grey", fontSize: "20px" }} />
          </div>
        }
        resizeHandles={["se"]}
        onResizeStop={(e, data) => {
          if (onHeightChange) onHeightChange(data.size.height);
        }}>
        <div className="ag-theme-alpine grid-container">
          <AgGridReact
            columnDefs={columnDefs}
            rowData={rowData}
            defaultColDef={defaultColDef}
            domLayout="normal"
            onGridReady={onGridReady}
            rowSelection={rowSelection}
            onSelectionChanged={onSelectionChanged}
            getRowStyle={getRowStyle}
            onColumnMoved={onColumnMoved}
            onDragStopped={onDragStopped}
            {...memoizedGridOptions}
            // theme={theme}
          />
        </div>
      </ResizableBox>
    );
  }
);

Grid.displayName = "Grid";

export default Grid;